import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { forbiddenNameValidator } from "./data-validators.service";

@Directive({
  selector: '[forbiddenSubstring]',
  providers: [{provide: NG_VALIDATORS, useExisting: ForbiddenSubstringValidatorDirective, multi: true}],
  standalone: false
})
export class ForbiddenSubstringValidatorDirective implements Validator {
  @Input('forbiddenSubstring') forbiddenSubstring = '';

  validate(control: AbstractControl): ValidationErrors | null {
    return this.forbiddenSubstring ? forbiddenNameValidator(new RegExp(this.forbiddenSubstring, 'i'))(control)
                              : null;
  }
}
